import { execute } from "../../helpers/apiInstance";

export function fetchAppData() {
    return execute('GET', '/ui/get-app-data');
}


export function fetchUserData() {
    return execute('GET', '/ui/apis/get-user-data');
}

